import { render, staticRenderFns } from "./form-table-preview.vue?vue&type=template&id=d3c5b4d0&scoped=true&"
import script from "./form-table-preview.vue?vue&type=script&lang=js&"
export * from "./form-table-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-table-preview.vue?vue&type=style&index=0&id=d3c5b4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c5b4d0",
  null
  
)

component.options.__file = "form-table-preview.vue"
export default component.exports